<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-12">
          <div class="element-wrapper">
            <div class="element-box">
              <form @submit="guardar">
                <h5 v-if="!current.pk" class="form-header">Nueva Unidad de Medida</h5>
                <div v-if="!current.pk" class="form-desc">Adición Unidad de Medida</div>
                <h5 v-if="current.pk" class="form-header">Edición de Unidad de Medida</h5>

                <div class="row">
                  <div class="col-lg-9 col-sm-12 col-md-12">
                    <div class="form-group">
                      <label
                        v-bind:class="{ 'text-danger': current.errors.nombre && current.errors.nombre.length > 0 }"
                      >Nombre</label>
                      <input
                        v-model="current.nombre"
                        autofocus="autofocus"
                        class="form-control"
                        placeholder="Nombre"
                        v-bind:class="{ 'is-invalid': current.errors.nombre && current.errors.nombre.length > 0 }"
                        type="text"
                      />
                      <small
                        v-if="current.errors && current.errors.nombre"
                        class="form-text text-danger"
                      >{{ current.errors.nombre[0] }}</small>
                    </div>
                  </div>
                  <div class="col-lg-3 col-sm-12 col-md-12">
                    <div class="form-group">
                      <label
                        v-bind:class="{ 'text-danger': current.errors.cantidad_unidades && current.errors.cantidad_unidades.length > 0 }"
                      >Cantidad de Unidades</label>
                      <input
                        v-model="current.cantidad_unidades"
                        class="form-control"
                        placeholder="Cantidad de Unidades"
                        type="text"
                        v-bind:class="{ 'is-invalid': current.errors.cantidad_unidades && current.errors.cantidad_unidades.length > 0 }"
                      />
                      <small
                        v-if="current.errors && current.errors.cantidad_unidades"
                        class="form-text text-danger"
                      >{{ current.errors.cantidad_unidades[0] }}</small>
                    </div>
                  </div>
                </div>

                <div class="form-buttons-w">
                  <button class="btn btn-primary" type="submit">Guardar</button>
                  <router-link
                    class="btn btn-default"
                    :to="{ name: 'cat-unidadesmedidas', params: {  }}"
                  >
                    <i class="fa fa-back"></i>
                    Volver al Listado
                  </router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import _ from "lodash";
import PaginationComponent from "@/components/utils/PaginationComponent";
import UnidadMedidaService from "@/services/catalogos/UnidadMedidaService";
import Notifications from "@/notifications/notifications";

export default {
  data() {
    return {
      current: {
        errors: {}
      }
    };
  },

  computed: {},
  mounted() {
    if (this.$route.params.id) {
      UnidadMedidaService.getById(this.$route.params.id).then(response => {
        this.current = response.data;
        this.current.errors = [];
      });
    }
  },

  methods: {
    guardar(e) {
      let self = this;
      e.preventDefault();
      var current = Object.assign({}, this.current);
      if (current.id == null) {
        delete current.id;
      }
      UnidadMedidaService.save(current)
        .then(res => {
          self.current = res.data;
          self.current.errors = {};
          Notifications.alert.success(
            "Unidad de Medida",
            "Se ha guardado la Información."
          );
          self.$router.push({
            name: "cat-unidadesmedidas-editar",
            params: { id: self.current.id }
          });
        })
        .catch(error => {
          if (error.response) {
            self.current.errors = error.response.data;
          }
        });
    },
    showModal(e) {
      e.preventDefault();
    }
  }
};
</script>
